import React, { useState } from 'react';
import Popup from "../imagepopup";

function Cibc() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setSelectedImage("");
  };
  return (
    
    <section className="sec-box project section-padding radius-15">
        <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center">
              <div className="next ml-auto">
                <h6 className="sub-title back-to-work">
                  <a href="/works">
                  <i className="fas fa-long-arrow-alt-left"></i> Back to works
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-11">
          <div className="img mb-80">
            <img
              src="/assets/imgs/works/p44.jpg"
              alt=""
              className="radius-5"
            />
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="cont md-mb50">
              <h3 className="mb-15 fw-500">Project Description:</h3>
                <p>
                Developed and enhanced CIBC’s Onboarding and Sales Applications using Pega COSMOS, ensuring compliance with CIBC’s usability standards, accessibility guidelines, and functional requirements. The project focused on creating a modern, user-friendly, and efficient platform for customer onboarding, account setup, and sales processes.
                </p>
                <p className="mt-15">
                Led the UI/UX design and development to deliver a seamless, accessible, and responsive interface, optimizing user journeys across web and mobile platforms. Integrated Pega Case Management and Decisioning to automate workflows, improve operational efficiency, and enhance customer experience.
                </p>
                <div className="mt-30">
                <h6 className="mb-15 line-height-28">
                  Roles & Responsibilities:
                  </h6>

                  <p>As a <strong>UI/UX Specialist </strong>, I was responsible for:</p>
                  <ul className="rest list-arrow mt-50">
                    <li>
                      <h6 className="inline fz-15">
                      Pega COSMOS Implementation: Designed and customized UI components using Pega COSMOS, ensuring adherence to CIBC’s usability standards and design principles.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      UI/UX Design & Accessibility: Developed an intuitive and visually appealing interface, incorporating WCAG-compliant accessibility features, improved navigation, and responsive layouts.
                      </h6>
                    </li>
                    <li className="mt-20">
                   
                      <h6 className="inline fz-15">
                      User Experience Optimization: Conducted usability testing and iterative design enhancements based on user feedback to improve workflow efficiency and engagement.
                      </h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">
                      Functional Enhancements & Customization: Led the development of custom UI components, dynamic layouts, and skin rules to extend COSMOS capabilities for enhanced user interactions.
                      </h6>
                    </li>
                    <li className="mt-20">
                   
                   <h6 className="inline fz-15">
                   Cross-Team Collaboration: Worked closely with business analysts, accessibility experts, developers, and stakeholders to align the UI/UX with business objectives and regulatory requirements.
                   </h6>
                 </li>
                 <li className="mt-20">
                   <h6 className="inline fz-15">
                   Performance & Scalability Optimization: Ensured efficient UI rendering, optimized rule execution, and implemented best practices to improve application performance.
                   </h6>
                 </li>
                 <li className="mt-20">
                   <h6 className="inline fz-15">
                   Agile Development & Leadership: Led multiple UI teams, conducted code reviews, and enforced best practices in Pega UI/UX development to ensure high-quality deliverables.
                   </h6>
                 </li>
                 <li className="mt-20">
                      <h6 className="inline fz-15">API Integration Support: Worked closely with backend teams to integrate REST APIs for real-time service booking and dealer updates.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Designed Out of box Custom components that were scalable and
                      reusable across all future projects.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Developing customized Pega Skin for all applications across all
Pega Labs for CIBC and creating Responsive Interface with
customized UI components based on application requirements.</h6>
                    </li>
                    <li className="mt-20">
                      <h6 className="inline fz-15">Analyzed and reviewed whether CIBC Branding Guidelines are
                      maintained for the UI Components developed on the Pega Platform.</h6>
                    </li>
                
                  </ul>

                  <p className="mt-25">This project played a crucial role in modernizing CIBC’s onboarding and sales platforms, improving customer engagement, reducing processing time, and ensuring compliance with banking industry standards.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="info sub-bg" id="sticky_item">
                <ul>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="far fa-calendar-alt mr-10"></i> Date :
                    </span>
                    <p>June 2021</p>
                  </li>
                  <li className="mb-30">
                    <span className="sub-title">
                      <i className="fas fa-list-ul mr-10"></i> Categories :
                    </span>
                    <p>UI/UX Specialist</p>
                  </li>
                  <li>
                    <span className="sub-title">
                      <i className="far fa-user mr-10"></i> Client :
                    </span>
                    <p>CIBC</p>
                  </li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="imgs mt-80">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="row md-marg">
              <div className="col-md-6">
                <div className="img sm-mb30">
                  <img src="/assets/imgs/works/p48.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p48.jpg")} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="img">
                  <img src="/assets/imgs/works/p43.jpg" alt="" onClick={() => handleImageClick("/assets/imgs/works/p43.jpg")} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="next-prev">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            <div className="d-flex align-items-center mt-80 pt-80 bord-thin-top">
              <div className="prev">
                <h6 className="sub-title">
                  <a href="/sunlife">
                    <i className="fas fa-long-arrow-alt-left"></i> Prev Project
                  </a>
                </h6>
              </div>
              <div className="next ml-auto">
                <h6 className="sub-title">
                  <a href="/scotiabank">
                    next Project <i className="fas fa-long-arrow-alt-right"></i>
                  </a>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>
                  {/* Popup for images */}
                  <Popup
        isOpen={isPopupOpen}
        closePopup={closePopup}
        popupImage={selectedImage}
      />
    </section>
  );
}

export default Cibc;
